// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1w-vp","content":"styles_content__2plxI","selectAll":"styles_selectAll__3o6_n"};